import React, { useContext } from 'react';
import Heading from '../../components/Typography/Heading/Heading';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { FlowContext } from '../../core/flow-engine';
import { navigateToExternal } from '../../core/util';
import styles from './style.css';

const RJUnsubscribeScreen = () => {
  const { appState } = useContext(FlowContext);
  const {
    store: { loadedData }
  } = appState;
  const unsubscribeSuccessful = loadedData?.RJUnsubscribeSuccessful;

  const headingText = unsubscribeSuccessful
    ? `You've successfully unsubscribed from emails regarding your new account application.`
    : `An error has occured attempting to unsubscribe.`;
  const subHeadingText = `If you are a T. Rowe Price customer and wish to change your email options or fully unsubscribe from T. Rowe Price email, please log in to your account and access your email preferences.`;

  return (
    <div className="container">
      <div className="headers-wrapper">
        <Heading text={headingText} />
        <SubHeading text={subHeadingText} />
      </div>
      <div className="unsubscribe-btn-container">
        <MFBeaconButton
          variant="primary"
          size="normal"
          id="returnJourneyEmailContinue"
          className="continue-btn"
          onClick={() =>
            navigateToExternal(
              `${window.location.origin}/personal-investing/index.html`
            )
          }
          label="Go to Personal Investing"
        />
      </div>
      <PhoneNumber screen="default" />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RJUnsubscribeScreen;
